import {IMaskFormatter} from './IMaskFormatter';

export class PhoneWithExtensionMask implements IMaskFormatter {
    public dividers: string[];
    public inputElement: any;
    public placeholder = '(XXX)XXX-XXXX XXXXX';
    static phoneMask = '(***)***-**** *****';
    public captureCaret;

    // returns the model value restricting it to numbers with slashes(/) appended.
    getModelValue(event, value): string {
        let modelValue = value;
        for (var i = 0; i < this.dividers.length; i++) {
            while (modelValue.indexOf(this.dividers[i]) > -1) {
                modelValue = modelValue.replace(this.dividers[i], '');
            }
        }

        if (modelValue.length !== 0) {
            if (modelValue.match(/^[0-9]*$/)) {   // Accepts only the numbers
                return modelValue;
            } else {
                modelValue = modelValue.toString();  // Removes the non numeric character
                return modelValue.slice(0, -1);
            }
        }
        return modelValue;
    }

    setCaretOnClick(model: string): void {
        const caretPos = model.length;
        console.log('caret position', caretPos);
    }

    // Jumps the input caret based on the position. Drives the user to next input location.
    setCaret(model: string, event: any): void {
        let caretPos = model.length + 1;
        if (model.length !== 0) {
            if (model.length >= 3) {
                caretPos++;
            }
            if (model.length >= 6) {
                caretPos = caretPos + 1;
            }
        } else {
            caretPos = 1;
        }
        if (this.inputElement !== null) {
            if (this.inputElement.createTextRange) {
                const range = this.inputElement.createTextRange();
                range.move('character', caretPos);
                range.select();
            } else {
                if (this.inputElement.selectionStart) {
                    this.inputElement.focus();
                    this.inputElement.setSelectionRange(caretPos, caretPos);
                } else {
                    this.inputElement.focus();
                }
            }
        }

        if (event.which === 8 && model.length === 6) {  // backspace operation escaping the slashes
            this.inputElement.setSelectionRange(8, 8);
        }
        if (event.which === 8 && model.length === 3) {
            this.inputElement.setSelectionRange(4, 4);
        }
    }

    // transforms to  '  /  /   '
    padString(str: string) {
        const pad = '          ';
        return (str + pad).substring(0, pad.length);
    }

    restrictInput(modelValue: string): boolean {
        // user cannot enter more than 15 numeric characters including extension (602) 555-1212 +54321
        if (modelValue) {
            return modelValue.length <= 15;
        }
    }
}
